import { apiClient } from "../api/apiClient.js";

// Thin fetch wrappers over the Prompt 110 Assignment Onboarding / Device /
// SIM Binding API. This file only ever calls the four real, assignment-
// scoped P110 routes (view onboarding, bind device, bind SIM, mark ready
// for mobile handover) - it never calls a heartbeat/location/tracking/
// geofence/face-recognition API (none of those exist anywhere in this
// codebase), and there is no list endpoint here to wrap - P110 has only an
// assignment-scoped detail endpoint, never a cross-assignment onboarding
// list, so this file does not invent one.

const ASSIGNMENTS_PATH = "/backoffice/thailand-jobs/assignments";

// Detail fetch requires a real, non-empty assignmentId - this file never
// issues a request for a missing/blank id.
export function getAssignmentOnboarding(assignmentId) {
  if (!assignmentId) {
    throw new Error("getAssignmentOnboarding requires an assignmentId");
  }
  return apiClient.get(`${ASSIGNMENTS_PATH}/${encodeURIComponent(assignmentId)}/onboarding`);
}

// request is the exact DeviceBindingRequest shape (deviceFingerprint,
// macAddress, imei, platform, appPackageId, appVersion, note) - the real
// endpoint always masks deviceFingerprint/macAddress/imei on every
// response, this file never reads or forwards a raw value anywhere else.
export function bindAssignmentDevice(assignmentId, request) {
  if (!assignmentId) {
    throw new Error("bindAssignmentDevice requires an assignmentId");
  }
  return apiClient.post(`${ASSIGNMENTS_PATH}/${encodeURIComponent(assignmentId)}/device-binding`, request);
}

// request is the exact SimBindingRequest shape (phoneNumber, carrierName,
// simSerial, note) - the real endpoint always masks phoneNumber/simSerial
// on every response.
export function bindAssignmentSim(assignmentId, request) {
  if (!assignmentId) {
    throw new Error("bindAssignmentSim requires an assignmentId");
  }
  return apiClient.post(`${ASSIGNMENTS_PATH}/${encodeURIComponent(assignmentId)}/sim-binding`, request);
}

// Sends no request body: the real endpoint
// (POST .../assignments/{assignmentId}/mobile-handover-ready) takes no
// payload, only the id in the path (mirrors
// ../thailandJobs/thailandJobsApi.js's markJobReadyForMatching). This call
// only ever flips the assignment's own onboardingStatus to
// ReadyForMobileHandover - it never starts tracking, regardless of what
// the backend response looks like (canStartTracking is always false on
// every response this endpoint returns).
export function markAssignmentReadyForMobileHandover(assignmentId) {
  if (!assignmentId) {
    throw new Error("markAssignmentReadyForMobileHandover requires an assignmentId");
  }
  return apiClient.post(`${ASSIGNMENTS_PATH}/${encodeURIComponent(assignmentId)}/mobile-handover-ready`);
}
